function hasActiveWCSession() {
  const cookies = document.cookie;
  return (
    cookies.includes("woocommerce_cart_hash") ||
    cookies.includes("wordpress_logged_in_")
  );
}

export function getOrCreateToastContainer() {
  let container = document.getElementById("wc-toast-container");
  if (!container) {
    container = document.createElement("div");
    container.id = "wc-toast-container";
    document.body.insertAdjacentElement("afterbegin", container);
  }
  return container;
}

export function handleNotice(notice, container, timeout = 5000) {
  if (notice.dataset.wcToastHandled) return;
  notice.dataset.wcToastHandled = "1";

  const wrapper = document.createElement("div");
  wrapper.className = "wc-toast-item";
  wrapper.appendChild(notice);
  container.appendChild(wrapper);

  const dismiss = () => {
    wrapper.style.transition = "opacity 0.5s, transform 0.5s";
    wrapper.style.opacity = "0";
    wrapper.style.transform = "translateX(20px)";
    setTimeout(() => wrapper.remove(), 500);
  };

  setTimeout(dismiss, timeout);

  const closeButton = document.createElement("button");
  closeButton.setAttribute("aria-label", "Fermer");
  closeButton.className = "wc-toast-close";
  closeButton.addEventListener("click", dismiss);
  wrapper.appendChild(closeButton);
}

function migrateCheckoutNoticeGroup(noticeGroup, container) {
  if (noticeGroup.dataset.wcToastHandled) return;
  noticeGroup.dataset.wcToastHandled = "1";

  noticeGroup.querySelectorAll("a[href^='#']").forEach((link) => {
    link.addEventListener("click", (e) => {
      const target = document.getElementById(link.getAttribute("href").slice(1));
      if (!target) return;
      e.preventDefault();
      const top = target.getBoundingClientRect().top + window.scrollY - 120;
      window.scrollTo({ top, behavior: "smooth" });
      target.focus({ preventScroll: true });
    });
  });

  const wrapper = document.createElement("div");
  wrapper.className = "wc-toast-item wc-toast-item--checkout-errors";
  wrapper.appendChild(noticeGroup);
  container.appendChild(wrapper);

  const dismiss = () => {
    wrapper.style.transition = "opacity 0.5s, transform 0.5s";
    wrapper.style.opacity = "0";
    wrapper.style.transform = "translateX(20px)";
    setTimeout(() => wrapper.remove(), 500);
  };

  setTimeout(dismiss, 10000);

  const closeButton = document.createElement("button");
  closeButton.setAttribute("aria-label", "Fermer");
  closeButton.className = "wc-toast-close";
  closeButton.addEventListener("click", dismiss);
  wrapper.appendChild(closeButton);
}

function migrateWrapper(wrapper, container) {
  const children = Array.from(wrapper.children);
  children.forEach((notice) => handleNotice(notice, container));
}

export function handleWooCommerceNotices() {
  if (!hasActiveWCSession()) {
    document
      .querySelectorAll(".woocommerce-notices-wrapper")
      .forEach((wrapper) => wrapper.remove());
    return;
  }

  const container = getOrCreateToastContainer();

  if (typeof jQuery !== "undefined" && jQuery.scroll_to_notices) {
    jQuery.scroll_to_notices = () => {};
  }

  document.querySelectorAll(".woocommerce-notices-wrapper").forEach((wrapper) => {
    if (wrapper.children.length > 0) {
      migrateWrapper(wrapper, container);
    }
  });

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;
        if (node.closest("#wc-toast-container")) return;

        if (node.classList.contains("woocommerce-NoticeGroup-checkout")) {
          const existing = container.querySelector(".wc-toast-item--checkout-errors");
          if (existing) existing.remove();
          migrateCheckoutNoticeGroup(node, container);
          return;
        }

        if (node.classList.contains("woocommerce-notices-wrapper")) {
          if (node.children.length > 0) migrateWrapper(node, container);
          return;
        }

        node.querySelectorAll(".woocommerce-notices-wrapper").forEach((wrapper) => {
          if (wrapper.children.length > 0) migrateWrapper(wrapper, container);
        });

        if (
          node.classList.contains("woocommerce-message") ||
          node.classList.contains("woocommerce-info") ||
          node.classList.contains("woocommerce-error")
        ) {
          handleNotice(node, container);
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
}
